<!-- src/components/HistoryPage.vue -->
<template>
  <div class="history-page">
    <!-- 顶部：返回 & 标题 & 清除 -->
    <header class="header">
      <button class="back-btn" @click="goBack">←</button>
      <div class="title">浏览历史</div>
      <button class="clear-btn" @click="clearHistory">清除</button>
    </header>

    <!-- 列表 -->
    <div v-if="historyList.length" class="history-list">
      <div
        v-for="item in historyList"
        :key="item.id"
        class="history-item"
        @click="playVideo(item.id)"
      >
        <img :src="item.img" alt="" class="thumb" />
        <div class="info">
          <div class="name">{{ item.title }}</div>
          <div class="sub">{{ item.subtitle }}</div>
        </div>
      </div>
    </div>

    <!-- 空状态 -->
    <div v-else class="empty">
      <p>暂无观看历史</p>
    </div>
  </div>
</template>

<script>
export default {
  name: 'HistoryPage',
  data() {
    return {
      historyList: []
    };
  },
  methods: {
    goBack() {
      this.$router.back();
    },
    loadHistory() {
      // 从 localStorage 加载，若无则使用示例数据
      const raw = localStorage.getItem('watchHistory');
      if (raw) {
        try {
          this.historyList = JSON.parse(raw);
          return;
        } catch {}
      }
      // 示例假数据
      this.historyList = [
        {
          id: 'h1',
          img: 'https://via.placeholder.com/80x106?text=%E6%9D%80%E6%88%AA%E5%8D%97%E7%93%9C%E6%80%AA',
          title: '杀戮南瓜怪',
          subtitle: '上次播放至 1 集'
        },
        {
          id: 'h2',
          img: 'https://via.placeholder.com/80x106?text=%E5%A4%AA%E7%A9%BA%E5%BC%82%E6%97%85',
          title: '太空异旅',
          subtitle: '上次播放至 1 集'
        },
        {
          id: 'h3',
          img: 'https://via.placeholder.com/80x106?text=007%E3%80%82%E6%97%A0%E6%83%91%E8%B5%B4%E6%AD%BB',
          title: '007：无暇赴死 (普通话)',
          subtitle: '上次播放至 1 集'
        },
        {
          id: 'h4',
          img: 'https://via.placeholder.com/80x106?text=%E6%95%A6%E5%88%BB%E5%B0%94%E5%85%8B',
          title: '敦刻尔克',
          subtitle: '上次播放至 1 集'
        },
        {
          id: 'h5',
          img: 'https://via.placeholder.com/80x106?text=%E5%AF%82%E9%9D%99%E4%B9%8B%E5%9C%B0%E3%80%82%EF%BC%92',
          title: '寂静之地 2 (普通话)',
          subtitle: '上次播放至 1 集'
        },
        {
          id: 'h6',
          img: 'https://via.placeholder.com/80x106?text=%E8%87%B4%E5%91%BD%E5%BC%AF%E9%81%93',
          title: '致命弯道',
          subtitle: '上次播放至 1 集'
        },
        {
          id: 'h7',
          img: 'https://via.placeholder.com/80x106?text=%E6%AD%BB%E7%A5%9E%E6%9D%A5%E4%BA%866',
          title: '死神来了 6：血脉诅咒',
          subtitle: '上次播放至 1 集'
        }
      ];
    },
    clearHistory() {
      localStorage.removeItem('watchHistory');
      this.historyList = [];
    },
    playVideo(id) {
      const msg = { action: 'playVideo', videoId: id };
      if (window.webkit?.messageHandlers?.nativeHandler) {
        window.webkit.messageHandlers.nativeHandler.postMessage(msg);
      } else if (window.Native?.postMessage) {
        window.Native.postMessage(JSON.stringify(msg));
      } else {
        console.log('播放模拟：', msg);
      }
    }
  },
  mounted() {
    this.loadHistory();
  }
};
</script>

<style scoped>
.history-page {
  font-family: -apple-system, BlinkMacSystemFont, sans-serif;
  padding: 0;
  overscroll-behavior: none;
  -webkit-overflow-scrolling: auto;
}

/* 头部 */
.header {
  display: flex;
  align-items: center;
  padding: 0 12px;
  height: 44px;
  background: #fff;
  box-shadow: 0 1px 0 #e0e0e0;
}
.back-btn,
.clear-btn {
  background: none;
  border: none;
  color: #1890ff;
  font-size: 16px;
  cursor: pointer;
}
.title {
  flex: 1;
  text-align: center;
  font-size: 17px;
  font-weight: 500;
}

/* 列表 */
.history-list {
  margin-top: 8px;
}
.history-item {
  display: flex;
  align-items: center;
  padding: 8px 12px;
  background: #fff;
  border-bottom: 1px solid #f0f0f0;
  cursor: pointer;
}
.thumb {
  width: 80px;
  height: 106px;
  object-fit: cover;
  border-radius: 4px;
}
.info {
  margin-left: 12px;
}
.name {
  font-size: 16px;
  color: #333;
  margin-bottom: 4px;
}
.sub {
  font-size: 13px;
  color: #888;
}

/* 空状态 */
.empty {
  display: flex;
  align-items: center;
  justify-content: center;
  height: calc(100vh - 44px);
  color: #999;
}
</style>